import React, { use, useState, useRef } from 'react';
import { Box, Button, T } from '@veracity/vui';

const ImageUpload = ({ value, onChange, label, required }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        if (!file.type.startsWith('image/')) {
            alert('Please select an image file.');
            return;
        }

        setSelectedFile(file);
        setFileName(file.name);

        onChange(file);
    };

    const handleSelectFile = () => {
        fileInputRef.current?.click();
    }

    const handleRemove = () => {
        setFileName('');
        setSelectedFile(null);
        onChange(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    return (
        <Box flexDirection="column" w="100%" mb={2}>
            <T mb={1}>
                {label}
                {required && <span style ={{ color: 'red'}}>*</span>}
            </T>

            <Box flexDirection="row" alignItems="center" gap={2}>
                <Button 
                    onClick={handleSelectFile}
                    iconRight="falCloudUpload"
                    variant="primaryDark"                    
                >
                    {selectedFile ? 'Change Image' : 'Select Image'}
                </Button>

                {fileName && (
                    <Box flexDirection="row" alignItems="center" maxW="80%">
                        <T maxW="80%">{fileName}</T>
                        <Button
                            icon="falTrashAlt"
                            variant="secondaryDark"
                            onClick={handleRemove}
                            ml={2}
                        />
                    </Box>
                )}

                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
            </Box>
        </Box>
    );
};

export default ImageUpload;